import styled from 'styled-components';

const Wrapper = styled.article`
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);
  transition: box-shadow 0.2s, transform 0.2s;
  border-left: 4px solid ${(props) => props.color};

  &:hover {
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    transform: translateY(-2px);
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.75rem;
  }

  .count {
    display: block;
    font-size: 2.5rem;
    font-weight: 800;
    color: ${(props) => props.color};
    letter-spacing: -0.03em;
    line-height: 1;
    margin-bottom: 0.35rem;
  }

  .title {
    font-size: 0.82rem;
    font-weight: 600;
    color: #64748b;
    text-transform: capitalize;
    letter-spacing: 0.03em;
    margin: 0;
  }

  .icon {
    width: 52px;
    height: 52px;
    background: ${(props) => props.bcg};
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      font-size: 1.5rem;
      color: ${(props) => props.color};
    }
  }
`;

export default Wrapper;
